import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { unwrappedNavigationCompetitionIdAtom } from '@/atoms/navigation';
import { LEAGUE_BASE_ROUTE } from '@/utils/classicLinks';
import { useLeagueNavigationItems } from './subNavigation/useLeagueNavigationItems';

export const useLeagueNavigationItem = () => {
  const { t } = useTranslation('navigation');
  const iqLeagueId = useAtomValue(unwrappedNavigationCompetitionIdAtom);
  const leagueRoute = `${LEAGUE_BASE_ROUTE}/${iqLeagueId}/league-table`;

  return {
    id: 'leagues',
    icon: 'League' as const,
    path: leagueRoute,
    label: t('crossPlatform.primary.leagues'),
    subNav: useLeagueNavigationItems(),
  };
};
